import { Link, NavLink } from "react-router-dom";
import CountryBadge from "@/components/common/CountryBadge";
import LogoMark from "@/components/common/LogoMark";

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  `px-3 py-2 rounded-md text-sm font-medium transition-colors ${
    isActive ? "text-primary" : "text-muted-foreground hover:text-foreground"
  }`;

const SiteHeader = () => {
  return (
    <header className="border-b bg-background/80 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto flex items-center justify-between py-3">
        <div className="flex items-center gap-2">
          <Link to="/" className="font-semibold tracking-tight text-lg flex items-center gap-2" aria-label="US Height Percentiles home">
            <LogoMark className="h-5 w-5 text-primary" />
            <span>US Height Percentiles</span>
          </Link>
          <CountryBadge code="us" label="US" />
        </div>
        <nav className="hidden md:flex items-center gap-1">
          <NavLink to="/" className={navLinkClass} end>
            Calculator
          </NavLink>
          <NavLink to="/average-male-height-us" className={navLinkClass}>
            Avg Male Height
          </NavLink>
          <NavLink to="/average-female-height-us" className={navLinkClass}>
            Avg Female Height
          </NavLink>
          <NavLink to="/us-height-distribution" className={navLinkClass}>
            Distribution
          </NavLink>
          <NavLink to="/methodology" className={navLinkClass}>
            Methodology
          </NavLink>
          <NavLink to="/sources" className={navLinkClass}>
            Sources
          </NavLink>
          <NavLink to="/contact" className={navLinkClass}>
            Contact
          </NavLink>
        </nav>
      </div>
    </header>
  );
};

export default SiteHeader;
